import { Action, ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { usersReducer, UsersState } from './users/users.reducer';
import { candidatesReducer, CandidatesState } from './candidates/candidates.reducer';
import { projectsReducer, ProjectsState } from './projects/projects.reducer';
import { notesReducer, NotesState } from './notes/notes.reducer';
import { chatbotReducer, ChatbotState } from './chatbot/chatbot.reducer';
import { candidateDnaReducer, CandidateDnaState } from './candidate-dna/candidate-dna.reducer';
import { rolesThatFitReducer, RolesThatFitState } from './roles-that-fit/roles-that-fit.reducer';

export interface CollectionsState {
  candidates: CandidatesState;
  projects: ProjectsState;
  users: UsersState;
  notes: NotesState;
  chatbot: ChatbotState;
  candidateDna: CandidateDnaState;
  rolesThatFit: RolesThatFitState;
}

export const reducers: ActionReducerMap<CollectionsState, Action> = {
  candidates: candidatesReducer,
  projects: projectsReducer,
  users: usersReducer,
  notes: notesReducer,
  chatbot: chatbotReducer,
  candidateDna: candidateDnaReducer,
  rolesThatFit: rolesThatFitReducer,
};

export const getCollectionsState = createFeatureSelector<CollectionsState>('collections');
